import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpStatusCode } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { ConfigurationService } from 'mbs-ui-shared@services/configuration.service';
import { EnvironmentService } from 'mbs-ui-shared@services/environments.service';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { isRmmWarehouseRequest } from '../helpers/rmm-warehouse-request.helper';

/**
 * Will reload page in case of ServiceUnavailable (503) error
 */
@Injectable()
export class ServiceUnavailableInterceptor implements HttpInterceptor {
  private config = inject(ConfigurationService);
  private environment = inject(EnvironmentService);

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const excludedCommands = ['/commands/invokepscommand', '/commands/invokeactivecommand'];
    const isExcludedByCommand = excludedCommands.some((command) => req.url.includes(command));

    return next.handle(req).pipe(
      catchError((e) => {
        if (
          e.status === HttpStatusCode.ServiceUnavailable &&
          this.environment.production &&
          !isExcludedByCommand &&
          !isRmmWarehouseRequest(req, this.config)
        ) {
          location.reload();
        }

        throw e;
      })
    );
  }
}
